module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15JszlG/tc-custom/9781426850639.jpg?1743843169258",
      "alt": "This image is the cover for the book Captain's Lady"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Captain's Lady\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Captain James Templeton's orders from General Washington are clear. His target: Lord Bennington, a member of George III's Privy Council. The assignment: find Bennington's war plans. The risks: the future of the East Florida Colony, Jamie's life…and his heart. In spite of the dangers of their hopeless situation, he's fallen in love with Lady Marianne Moberly, Lord Bennington's daughter."), _c('br'), _c('br'), _vm._v("Desperate to protect his country, Jamie carries out his orders with a heavy heart. But Marianne's persistence is a challenge he never expected. With love and faith, they must navigate troubled waters to win their future together."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Louise M. Gouge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning South Carolina author Louise M. Gouge writes historical and contemporary romance. Married to David Gouge for 54 years, she is now widowed. She is mother of four amazing adult children and grandmother of eight absolutely perfect grandchildren. With a BA in Creative Writing and a master's degree in Liberal Studies, Louise taught composition and humanities at Valencia College in Kissimmee, Florida. Now happily retired from teaching, she writes full time.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0